.paragraph {
    margin: var(--mantine-spacing-md) 0;

    &:first-child {
        margin-top: 0;
    }

    &:last-child {
        margin-bottom: 0;
    }
}
